import ajax from 'Site/js/util/ajax.fetch';
import { mapActions, mapState } from 'vuex';

export default {
    computed: mapState(['config', 't']),
    methods: {
        ...mapActions(['notify', 'showMediaViewer']),
        highlight(mediaItem) {
            const highlightedItems = this.allMedia.filter(checkMedia => checkMedia.highlighted === true);
            if (highlightedItems.length >= 4) {
                this.notify({ msg: this.t.max_highlights, type: 'error' });
            } else {
                mediaItem.highlighted = true;
                ajax.update('club', { addMedia: mediaItem.id, id: this.config.data.id }).then((response) => {
                    this.notify({ msg: response.message });
                });
            }
        },
        unhighlight(mediaItem, filter = false) {
            mediaItem.highlighted = false;
            if (filter) {
                this.allMedia = this.allMedia.filter(checkMedia => checkMedia !== mediaItem);
            }
            ajax.update('club', { removeMedia: mediaItem.id, id: this.config.data.id }).then((response) => {
                this.notify({ msg: response.message });
            });
        },
        mediaViewer(start) {
            this.showMediaViewer({ media: this.allMedia, start });
        },
    }
};
